import isMobileLayout from '../utils/isMobileLayout';
import { useEffect, useState } from 'react';

function GeocercasPanel({
  geocercas = [],
  setGeocercas,
  modoCrearGeocerca,
  setModoCrearGeocerca,
  geocercaTemporal,
  setGeocercaTemporal,
  geocercaSeleccionada,
  setGeocercaSeleccionada,
  vehiculoSeleccionado,
  monitorUserId
}) {
  const [nombre, setNombre] = useState('');

  const [alarmaEncendida, setAlarmaEncendida] = useState(true);
const [avisarEntrada, setAvisarEntrada] = useState(true);
const [avisarSalida, setAvisarSalida] = useState(true);
  const [radio, setRadio] = useState(150);
  const [isMobile, setIsMobile] = useState(isMobileLayout);
  const [eliminandoId, setEliminandoId] = useState(null);
  const [actualizandoAlarmaId, setActualizandoAlarmaId] =
  useState(null);

useEffect(() => {
  const checkMobile = () => {
    setIsMobile(isMobileLayout());
  };

  checkMobile();

  window.addEventListener('resize', checkMobile);

  return () => {
    window.removeEventListener('resize', checkMobile);
  };
}, []);
  const tituloGeocercas = vehiculoSeleccionado
  ? `Geocercas de ${vehiculoSeleccionado.name || 'activo'}`
  : 'Geocercas activas';

 const vehicleId =
  vehiculoSeleccionado?.maccezVehicleId ??
  vehiculoSeleccionado?.id;

useEffect(() => {
  const controller = new AbortController();

  async function cargarGeocercas() {
    try {
      const token = localStorage.getItem('token');

      const url = isMobile && vehicleId
        ? `/api/geofences?vehicleId=${encodeURIComponent(vehicleId)}&monitorUserId=${encodeURIComponent(monitorUserId)}`
        : `/api/geofences?monitorUserId=${encodeURIComponent(monitorUserId)}`;

      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        signal: controller.signal
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(
          data.message || 'No se pudieron cargar las geocercas'
        );
      }

      if (!controller.signal.aborted) {
        setGeocercas(data.geofences || []);
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('ERROR CARGANDO GEOCERCAS:', error);
      }
    }
  }

  setGeocercas([]);
  cargarGeocercas();

  return () => controller.abort();
}, [isMobile, vehicleId, monitorUserId, setGeocercas]);

  useEffect(() => {
    if (!geocercaTemporal) return;

    setRadio(geocercaTemporal.radius || 150);
  }, [geocercaTemporal]);

  function iniciarCreacion() {
    setNombre('');
    setAlarmaEncendida(true);
setAvisarEntrada(true);
setAvisarSalida(true);
    setRadio(150);
    setGeocercaTemporal(null);
    setGeocercaSeleccionada(null);
    setModoCrearGeocerca(true);
  }

  function cancelarCreacion() {
    setNombre('');
    setRadio(150);
    setGeocercaTemporal(null);
    setGeocercaSeleccionada(null);
    setModoCrearGeocerca(false);
  }

 async function guardarGeocerca() {
  if (!geocercaTemporal) {
    alert('Dibuja la geocerca en el mapa');
    return;
  }

  if (!nombre.trim()) {
    alert('Escribe un nombre para la geocerca');
    return;
  }

  const token = localStorage.getItem('token');

  try {
    const response = await fetch(`/api/geofences?monitorUserId=${encodeURIComponent(monitorUserId)}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
body: JSON.stringify({
  vehicleId:
    vehiculoSeleccionado?.maccezVehicleId ??
    vehiculoSeleccionado?.id,
  name: nombre.trim(),
  latitude: geocercaTemporal.latitude,
  longitude: geocercaTemporal.longitude,
  radius: Math.round(geocercaTemporal.radius || 150),
alarmEnabled: isMobile && alarmaEncendida,
notifyEntry: isMobile && avisarEntrada,
notifyExit: isMobile && avisarSalida
})
    });

    const data = await response.json();

    if (!data.success) {
      alert(data.message || 'No se pudo guardar la geocerca');
      return;
    }

    const nuevaGeocerca = {
      id: data.id || Date.now(),
      vehicle_id: vehicleId,
  alarm_enabled: alarmaEncendida ? 1 : 0,
  notify_entry: avisarEntrada ? 1 : 0,
  notify_exit: avisarSalida ? 1 : 0,
      name: nombre.trim(),
      latitude: geocercaTemporal.latitude,
      longitude: geocercaTemporal.longitude,
      radius: Math.round(geocercaTemporal.radius || 150),
      status: 'active'
    };

    setGeocercas((prev) => [
      nuevaGeocerca,
      ...prev
    ]);

    setNombre('');
    setGeocercaTemporal(null);
    setGeocercaSeleccionada(null);
    setModoCrearGeocerca(false);

  } catch (error) {
    console.error('Error guardando geocerca:', error);
    alert('Error guardando geocerca');
  }
}
  async function eliminarGeocerca(geo) {
  if (
    !window.confirm(
      `¿Eliminar la geocerca "${geo.name}"?`
    )
  ) {
    return;
  }

  setEliminandoId(geo.id);

  try {
    const token = localStorage.getItem('token');

    const response = await fetch(
      `/api/geofences/${encodeURIComponent(geo.id)}`,
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(
        data.message || 'No se pudo eliminar la geocerca'
      );
    }

    setGeocercas((anteriores) =>
      anteriores.filter(
        (item) => String(item.id) !== String(geo.id)
      )
    );

    setGeocercaSeleccionada((actual) =>
      String(actual?.id) === String(geo.id)
        ? null
        : actual
    );
  } catch (error) {
    alert(error.message);
  } finally {
    setEliminandoId(null);
  }
}

async function alternarAlarma(geo) {
  const alarmEnabled = Number(geo.alarm_enabled) !== 1;
  const tieneAvisos =
    Number(geo.notify_entry) === 1 ||
    Number(geo.notify_exit) === 1;

  const notifyEntry = tieneAvisos
    ? Number(geo.notify_entry) === 1
    : true;

  const notifyExit = tieneAvisos
    ? Number(geo.notify_exit) === 1
    : true;

  setActualizandoAlarmaId(geo.id);

  try {
    const token = localStorage.getItem('token');

    const response = await fetch(
      `/api/geofences/${encodeURIComponent(geo.id)}/alarm`,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          alarmEnabled,
          notifyEntry,
          notifyExit
        })
      }
    );

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(
        data.message || 'No se pudo actualizar la alarma'
      );
    }

    setGeocercas((anteriores) =>
      anteriores.map((item) =>
        String(item.id) === String(geo.id)
          ? {
              ...item,
              alarm_enabled: alarmEnabled ? 1 : 0,
              notify_entry: notifyEntry ? 1 : 0,
              notify_exit: notifyExit ? 1 : 0
            }
          : item
      )
    );
  } catch (error) {
    alert(error.message);
  } finally {
    setActualizandoAlarmaId(null);
  }
}

if (isMobile) {
    return (
      <div style={{ ...styles.wrapper, gap: '8px' }}>
        <div style={styles.summaryCardMobile}>
          <span>{tituloGeocercas}</span>
          <strong>{geocercas.length} guardadas</strong>
        </div>

        {!modoCrearGeocerca && vehicleId ? (
          <button
            type="button"
            style={styles.primaryButtonMobile}
            onClick={iniciarCreacion}
          >
            + Nueva geocerca
          </button>
        ) : modoCrearGeocerca ? (
          <div style={styles.createBox}>
            <strong style={styles.createTitle}>
              Nueva geocerca
            </strong>

            <p style={{ ...styles.empty, fontSize: '11px' }}>
              Mueve el mapa. Toca el lugar o pulsa
              «Marcar centro del mapa».
            </p>

            <input
              value={nombre}
              onChange={(event) =>
                setNombre(event.target.value)
              }
              placeholder="Nombre de la geocerca"
              maxLength={80}
              style={{ ...styles.input, height: '42px' }}
            />

            <label style={styles.opcionAlarmaMobile}>
  <input
    type="checkbox"
    checked={alarmaEncendida}
    onChange={(event) =>
      setAlarmaEncendida(event.target.checked)
    }
  />
  Alarma encendida
</label>

<label style={styles.opcionAlarmaMobile}>
  <input
    type="checkbox"
    checked={avisarEntrada}
    onChange={(event) =>
      setAvisarEntrada(event.target.checked)
    }
  />
  Avisar cuando entre
</label>

<label style={styles.opcionAlarmaMobile}>
  <input
    type="checkbox"
    checked={avisarSalida}
    onChange={(event) =>
      setAvisarSalida(event.target.checked)
    }
  />
  Avisar cuando salga
</label>

            {geocercaTemporal && (
              <span style={styles.meta}>
                Radio: {Math.round(
                  Number(geocercaTemporal.radius) || 150
                )} m · Ajústalo sobre el mapa
              </span>
            )}

            <div
              style={{
                display: 'grid',
                gridTemplateColumns:
                  geocercaTemporal ? '1fr 1fr' : '1fr',
                gap: '8px'
              }}
            >
              <button
                type="button"
                style={styles.cancelButton}
                onClick={cancelarCreacion}
              >
                Cancelar
              </button>

              {geocercaTemporal && (
                <button
                  type="button"
                  style={styles.saveButton}
                  onClick={guardarGeocerca}
                >
                  Guardar
                </button>
              )}
            </div>
          </div>
        ) : null}

        {!modoCrearGeocerca && (
          geocercas.length === 0 ? (
            <p style={styles.empty}>
              Aún no hay geocercas creadas.
            </p>
          ) : (
            <div
              style={{
                ...styles.list,
                maxHeight: '25dvh',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch'
              }}
            >
            {geocercas.map((geo) => (
  <div
    key={geo.id}
    style={{ display: 'flex', gap: '7px' }}
  >
    <button
      type="button"
      onClick={() => {
        setGeocercaTemporal(null);
        setGeocercaSeleccionada(geo);
      }}
      style={{
        ...styles.itemMobile,
        ...(geocercaSeleccionada?.id === geo.id
          ? styles.itemSelected
          : {}),
        flex: 1,
        minWidth: 0,
        textAlign: 'left',
        cursor: 'pointer'
      }}
    >
      <span style={styles.title}>{geo.name}</span>
      <span style={styles.meta}>{geo.radius} m{geo.vehicle_id == null ? " · Sin activo · Sin alarma" : ""}</span>
    </button>
<button
  type="button"
  disabled={actualizandoAlarmaId === geo.id || geo.vehicle_id == null}
  onClick={() => alternarAlarma(geo)}
  aria-label={
    Number(geo.alarm_enabled) === 1
      ? `Apagar alarma de ${geo.name}`
      : `Encender alarma de ${geo.name}`
  }
  style={{
    minWidth: '58px',
    padding: '0 8px',
    borderRadius: '12px',
    border: '1px solid rgba(148,163,184,0.35)',
    background:
      Number(geo.alarm_enabled) === 1
        ? '#16a34a'
        : '#475569',
    color: '#ffffff',
    fontSize: '11px',
    fontWeight: 800,
    cursor: 'pointer'
  }}
>
  {actualizandoAlarmaId === geo.id
    ? '…'
    : Number(geo.alarm_enabled) === 1
      ? 'ON'
      : 'OFF'}
</button>
    <button
      type="button"
      disabled={eliminandoId === geo.id}
      onClick={() => eliminarGeocerca(geo)}
      style={{
        ...styles.cancelButton,
        padding: '0 10px',
        flexShrink: 0
      }}
    >
      {eliminandoId === geo.id ? '…' : 'Eliminar'}
    </button>
  </div>
))}
            </div>
          )
        )}
      </div>
    );
  }
  return (
    <div style={styles.wrapper}>
      <div style={styles.summaryGrid}>
       <div
  style={
    isMobile
      ? styles.summaryCardMobile
      : styles.summaryCard
  }
>
          <span>{tituloGeocercas}</span>
          <strong>{geocercas.length}</strong>
        </div>

      <div
  style={
    isMobile
      ? styles.summaryCardMobile
      : styles.summaryCard
  }
>
          <span>Eventos hoy</span>
          <strong>0</strong>
        </div>
      </div>

      {!modoCrearGeocerca && vehicleId && (
        <button
          style={
  isMobile
    ? styles.primaryButtonMobile
    : styles.primaryButton
}
          onClick={iniciarCreacion}
        >
          + Nueva geocerca
        </button>
      )}

      {modoCrearGeocerca && (
        <div style={styles.createBox}>
          <div style={styles.createTitle}>
            Nueva geocerca
          </div>

          {!geocercaTemporal ? (
            <div style={styles.helpBox}>
              Haz clic sobre el mapa para ubicar la geocerca.
            </div>
          ) : (
            <>
              <input
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Nombre de la geocerca"
                style={styles.input}
              />

            
              <button
                style={styles.saveButton}
                onClick={guardarGeocerca}
              >
                Guardar geocerca
              </button>
            </>
          )}

          <button
            style={styles.cancelButton}
            onClick={cancelarCreacion}
          >
            Cancelar
          </button>
        </div>
      )}

      {geocercas.length === 0 ? (
        <p style={styles.empty}>
          Aún no hay geocercas creadas.
        </p>
      ) : (
        <div style={styles.list}>
          {geocercas.map((geo) => (
          <div
  key={geo.id}
  onClick={() => {
    setModoCrearGeocerca(false);
    setGeocercaTemporal(null);
    setGeocercaSeleccionada(geo);
  }}
  style={{
   ...(isMobile
  ? styles.itemMobile
  : styles.item),
    ...(geocercaSeleccionada?.id === geo.id
      ? styles.itemSelected
      : {})
  }}
>
              <div>
                <div style={styles.title}>
                  {geo.name}
                </div>

                <div style={styles.meta}>
                  Circular · {geo.radius} m
                </div>
              </div>

              <span style={styles.status}>
                Activa
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {

  opcionAlarmaMobile: {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  color: '#ffffff',
  fontSize: '12px',
  fontWeight: 700
},
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },

  summaryGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '8px'
  },

  summaryCard: {
    padding: '14px',
    borderRadius: '16px',
    background: 'rgba(3,18,40,0.62)',
    border: '1px solid rgba(34,197,94,0.18)',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    color: '#bbf7d0',
    fontSize: '11px',
    fontWeight: '800'
  },

primaryButtonMobile: {
  height: '42px',
  borderRadius: '12px',
  border: '1px solid #86efac',
  background: '#dcfce7',
  color: '#14532d',
  fontSize: '11px',
  fontWeight: '900',
  cursor: 'pointer'
},

  createBox: {
    padding: '12px',
    borderRadius: '16px',
    background: 'rgba(3,18,40,0.62)',
    border: '1px solid rgba(34,197,94,0.20)',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },

  createTitle: {
    color: '#ffffff',
    fontSize: '12px',
    fontWeight: '900'
  },

  helpBox: {
    padding: '12px',
    borderRadius: '12px',
    background: 'rgba(14,165,233,0.14)',
    border: '1px solid rgba(125,211,252,0.22)',
    color: '#dbeafe',
    fontSize: '12px',
    lineHeight: '1.4'
  },

  input: {
    height: '34px',
    borderRadius: '10px',
    border: '1px solid rgba(125,211,252,0.18)',
    background: 'rgba(15,23,42,0.78)',
    color: '#ffffff',
    padding: '0 10px',
    fontSize: '11px',
    outline: 'none'
  },

  saveButton: {
    height: '36px',
    borderRadius: '12px',
    border: 'none',
    background: '#22c55e',
    color: '#052e16',
    fontSize: '12px',
    fontWeight: '900',
    cursor: 'pointer'
  },

  cancelButton: {
    height: '34px',
    borderRadius: '12px',
    border: '1px solid rgba(148,163,184,0.20)',
    background: 'rgba(15,23,42,0.58)',
    color: '#cbd5e1',
    fontSize: '12px',
    fontWeight: '800',
    cursor: 'pointer'
  },

  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },

  item: {
    padding: '12px',
    borderRadius: '14px',
    background: 'rgba(15,23,42,0.66)',
    border: '1px solid rgba(34,197,94,0.16)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  title: {
    color: '#ffffff',
    fontSize: '12px',
    fontWeight: '900'
  },

  meta: {
    marginTop: '4px',
    color: '#86efac',
    fontSize: '10px',
    fontWeight: '700'
  },

  status: {
    padding: '4px 8px',
    borderRadius: '999px',
    background: 'rgba(34,197,94,0.16)',
    color: '#bbf7d0',
    fontSize: '9px',
    fontWeight: '900'
  },

  empty: {
    margin: 0,
    color: '#cbd5e1',
    fontSize: '13px',
    lineHeight: '1.5'
  },
  itemSelected: {
  border: '1px solid rgba(34,197,94,0.75)',
  boxShadow: '0 0 14px rgba(34,197,94,0.28)',
  background: 'rgba(21,128,61,0.24)'
},
summaryCardMobile: {
  padding: '10px',
  borderRadius: '12px',
  background: 'rgba(3,18,40,0.62)',
  border: '1px solid rgba(34,197,94,0.18)',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  color: '#bbf7d0',
  fontSize: '10px',
  fontWeight: '800'
},


itemMobile: {
  padding: '10px',
  borderRadius: '12px',
  background: 'rgba(15,23,42,0.66)',
  border: '1px solid rgba(34,197,94,0.16)',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}
 
};

export default GeocercasPanel;